import { NbDialogRef, NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { FormControl, FormBuilder,
    FormGroup,
    Validators, } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ApiService } from '../../shared/api.service';

@Component({
        selector: 'nb-dialog',
        template:`
       
        <nb-card style="width: 500px; height: 350px;" accent="info"  size="large">
        <nb-card-header>
          <div class="modal-header">
            <div class="popupTitle">
              <h5>Add Time Table</h5>
            </div>
          

          
            <button type="button" style="float:right" nbButton shape="semi-round" size="small" (click)="close();">X</button>
          </div>
        </nb-card-header>
        <nb-card-body>
        <div class="row">
                              <div class="col-md-4 " >
                                  Select date
                              </div>
                              <div class="col-md-1 ">
                                :
                              </div>
                              <div class="col-md-5 ">
                                <mat-select class="form-control" placeholder="Select Date" (selectionChange)="checkradio($event.value)">
                                  <mat-option  *ngFor="let datedata of examdates"  [value]="datedata?.date" >{{datedata?.date | date :  "dd.MM.y"}}</mat-option>
                                </mat-select>
                              </div>
                          </div>
                          <br><br><br><br>
                          <div class="row">
                              <button nbButton class="col-md-4 col-sm-4 col-xs-4 offset-md-4" (click)="saveexamdate()"
                              hero style="background-color: black;">Save Date</button><br>
                              <span *ngIf="showerror == true" style="color:red;">Select Date</span>
                          </div>
        
        </nb-card-body>
      </nb-card>

`,
providers:[
]
})

export class QatExamDate {
  @Input() studentId : String;
  @Input() applicationId : String;
  @Input() courseId : String;
  
  examdates: any;
  showerror = false;
  date_exam: any;
    

    constructor(
        protected api : ApiService,
        protected ref: NbDialogRef<QatExamDate>,
       ){
       
      
    }

    ngOnInit(): void {
      this.api.getQatExamDate(this.studentId)
      .subscribe(
        (data: any) => {
          this.examdates = data['data2'];
        },
        error => {
          console.error("Error", error);
        }
      )      
    }

    checkradio(x){
      this.date_exam = x;
    }

    saveexamdate(){
      if(this.date_exam == undefined){
        this.showerror = true;
      }else{
       
            this.api.saveAdminExamdate(this.date_exam,this.applicationId,this.courseId,this.studentId).subscribe(data => {
              if(data['status'] == 200){
              this.ref.close();
              }else if(data['status'] ==400){
              }
              error => {
                  console.error("Error in saveexamdate :", error);
              }
            });
      }
    }

      close(){
          this.ref.close()
      }
}
